import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src760788307/src/mds-docs/gatsby-theme-mds/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`We’re continually improving our Masala Design System. The following changes are listed by the date we completed each change.`}</p>
    <Link href="https://github.com/innovaccer/design-system" target="_blank" mdxType="Link">
    Source code
    </Link>
    <br />
    <br />
    <h2 {...{
      "id": "250-2--2021-09-29"
    }}>{`2.5.0-2  (2021-09-29)`}</h2>
    <h3 {...{
      "id": "highlights"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Calendar and DatePicker has new design and features for today date selection now. (7c3df346)`}</li>
      <li parentName="ul">{`EmptyState component now supports inline SVG image. (863d69b0)`}</li>
    </ul>
    <h3 {...{
      "id": "fixes"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Table/Grid horizontal scrolling issue is fixed. (a6949715)`}</li>
      <li parentName="ul">{`Modal is now vertically centered and can have flexible heights. (ef6072a7)`}</li>
      <li parentName="ul">{`Dropzone icon is visible now when we bring mouse to drop file over it. (5ba93be9)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements"
    }}>{`Improvements`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "documentation"
    }}>{`Documentation`}</h3>
    <ul>
      <li parentName="ul">{`Guideline for branch naming convention added. (1ef3cd96)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "250-1--2021-09-27"
    }}>{`2.5.0-1  (2021-09-27)`}</h2>
    <h3 {...{
      "id": "highlights-1"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-1"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-1"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-1"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-1"
    }}>{`Features`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "fixes-1"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Fixes the table header scroll when table body scroll (502cb1d1)`}</li>
      <li parentName="ul">{`Fixes the Tabs Component rendering issue with checking children component type (8525a4e7)`}</li>
      <li parentName="ul">{`Fixes the Datepicker snapshot which was getting updated as date changes (c001e925)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-1"
    }}>{`Improvements`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "documentation-1"
    }}>{`Documentation`}</h3>
    <p>{`NA`}</p>
    <hr></hr>
    <h2 {...{
      "id": "250-0--2021-09-22"
    }}>{`2.5.0-0  (2021-09-22)`}</h2>
    <h3 {...{
      "id": "highlights-2"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-2"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-2"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-2"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-2"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Added previous and next month dates in current month’s date in Calendar Component (4fe810bf)`}</li>
    </ul>
    <h3 {...{
      "id": "fixes-2"
    }}>{`Fixes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "improvements-2"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`Added test cases for Calendar Component (f22df8b6)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-2"
    }}>{`Documentation`}</h3>
    <p>{`NA`}</p>
    <hr></hr>
    <h2 {...{
      "id": "240--2021-09-22"
    }}>{`2.4.0  (2021-09-22)`}</h2>
    <h3 {...{
      "id": "highlights-3"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-3"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-3"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-3"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-3"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Automated the process of types bundling (21f435b0)`}</li>
      <li parentName="ul">{`A new InlineMessage Component has been added (f852b2a8)`}</li>
      <li parentName="ul">{`Added the events indicator on given date in Calendar Component (4714efa2)`}</li>
      <li parentName="ul">{`A Chip has been added to Datepicker Component to select today’s date (ee9e47e0)`}</li>
      <li parentName="ul">{`Tooltip in Icon Button Component has been added (f9f14233)`}</li>
    </ul>
    <h3 {...{
      "id": "fixes-3"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Removes the events type Array from Calendar Component (41abf4ef)`}</li>
      <li parentName="ul">{`zIndex for Backdrop Component has been fixed (055edb09)`}</li>
      <li parentName="ul">{`Border radius of Card Component has been fixed (c113a568)`}</li>
      <li parentName="ul">{`New Stories has been added to EmptyState Component and updated the existing story (af83ea74)`}</li>
      <li parentName="ul">{`Height of the Input field has been fixed when focus in EditableChipInput Component (bbb4f256)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-3"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`Added test cases for InputMask Component (e0f37b99)`}</li>
      <li parentName="ul">{`Added test cases for FileList Component (b36a44f1)`}</li>
      <li parentName="ul">{`Added test cases for Dropdown Component options and loading state (1cb98e93)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-3"
    }}>{`Documentation`}</h3>
    <p>{`NA`}</p>
    <hr></hr>
    <h2 {...{
      "id": "230--2021-09-10"
    }}>{`2.3.0  (2021-09-10)`}</h2>
    <h3 {...{
      "id": "highlights-4"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-4"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-4"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-4"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-4"
    }}>{`Features`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "fixes-4"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Improve padding of close button in overlays header  (4d4965b9) `}</li>
      <li parentName="ul">{`Fixes nested rows losing their open state in grid (aed5b032)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-4"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`Adds test cases for FileUploaderComponent (5604656c)`}</li>
      <li parentName="ul">{`Adds test cases for TimePicker component (4e776a46)`}</li>
      <li parentName="ul">{`Adds test cases for ChatMessage Component (0443446c)`}</li>
      <li parentName="ul">{`Adds test cases for slider component (fa82992a)`}</li>
      <li parentName="ul">{`Adds test cases for DateRangePicker component (8c5abb26)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-4"
    }}>{`Documentation`}</h3>
    <ul>
      <li parentName="ul">{`Embeds rich text editor storybook (f3a469da)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "230-2--2021-25-10"
    }}>{`2.3.0-2  (2021-25-10)`}</h2>
    <h3 {...{
      "id": "highlights-5"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-5"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-5"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-5"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-5"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Adds Close on Escape Keypress feature in Overlays (c2904387)`}</li>
    </ul>
    <h3 {...{
      "id": "fixes-5"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Fixes arrow click event argument in MetricInput (e4cf0bc5)`}</li>
      <li parentName="ul">{`Adds default state delete functionality in EditableChipInput (3a8415f7)`}</li>
      <li parentName="ul">{`Fixes done button and adds support for uncontrolled EditableChipInput (16a844be)`}</li>
      <li parentName="ul">{`Fixes done button and adds support for uncontrolled EditableInput (f0de36cd)`}</li>
      <li parentName="ul">{`Fixes onChange callback in InputMask (I18e111ce)`}</li>
      <li parentName="ul">{`Removes margin bottom from modal body when there is no footer (7470a273)`}</li>
      <li parentName="ul">{`Fixes nested row card border in Grid (132d0903)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-5"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`feat(Checkbox): Adds helptext in checkbox (1d41c6cc)`}</li>
      <li parentName="ul">{`feat(Radio): Adds helptext in radio (fc886989)`}</li>
      <li parentName="ul">{`Test(MetaList): Adds test cases for MetaList component (5023743f)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-5"
    }}>{`Documentation`}</h3>
    <ul>
      <li parentName="ul">{`Adds more content to scrolling modal story (c43c8fea)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "230-1--2021-08-10"
    }}>{`2.3.0-1  (2021-08-10)`}</h2>
    <h3 {...{
      "id": "highlights-6"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-6"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-6"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-6"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-6"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Improves Tabs API for custom tab (8018e724)`}</li>
    </ul>
    <h3 {...{
      "id": "fixes-6"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Adds type `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`button`}</code>{` to all components using Button component (7be54df8)`}</li>
      <li parentName="ul">{`Removes action Icon when input field is disabled (deeb1e1c)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-6"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`Adds not-allowed cursor in stepper for disabled step (a11a3dce)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-6"
    }}>{`Documentation`}</h3>
    <p>{`NA`}</p>
    <hr></hr>
    <h2 {...{
      "id": "230-0--2021-08-10"
    }}>{`2.3.0-0  (2021-08-10)`}</h2>
    <h3 {...{
      "id": "highlights-7"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-7"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-7"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-7"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-7"
    }}>{`Features`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "fixes-7"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Fixes missing file icon in FileList (920e5c42)`}</li>
      <li parentName="ul">{`Fixes disabled state in DatePicker (1826c560)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-7"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`Adds radio’s css for hover and active state (a025c7d4)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-7"
    }}>{`Documentation`}</h3>
    <ul>
      <li parentName="ul">{`Adds stepper stories (7274e111)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "220-2--2021-07-14"
    }}>{`2.2.0-2  (2021-07-14)`}</h2>
    <h3 {...{
      "id": "highlights-8"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-8"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-8"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-8"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-8"
    }}>{`Features`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "fixes-8"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Fixed table last page navigation and remember last page feature (e74cd502)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-8"
    }}>{`Improvements`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "documentation-8"
    }}>{`Documentation`}</h3>
    <p>{`NA`}</p>
    <hr></hr>
    <h2 {...{
      "id": "220-1--2021-07-12"
    }}>{`2.2.0-1  (2021-07-12)`}</h2>
    <h3 {...{
      "id": "highlights-9"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-9"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-9"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-9"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-9"
    }}>{`Features`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "fixes-9"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`updates material icons font files. (4f5fd6b7)`}</li>
      <li parentName="ul">{`fixes % width issue in overlays. (c1a4997d)`}</li>
      <li parentName="ul">{`adds support for string for cellType: ICON (c153e3e6)`}</li>
      <li parentName="ul">{`fixes width percent issue on initial render (fe12266d)`}</li>
      <li parentName="ul">{`fixes hover state for disabled tabs. (85117ede)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-9"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`adds test for chip and chipGroup components (5f4e4e8c)`}</li>
      <li parentName="ul">{`removes extra wrappers. (ab105189)`}</li>
      <li parentName="ul">{`adds button type to dropdown with apply button. (28aa3fda)`}</li>
      <li parentName="ul">{`adds focus state for tabs. (2365dc2e)`}</li>
      <li parentName="ul">{`sets Tabs withSeparator default to true. (27e22655)`}</li>
      <li parentName="ul">{`Uglify, brotli and gzip compression added. (101d71a6)`}</li>
      <li parentName="ul">{`adds Date.now mock. (2644524c)`}</li>
      <li parentName="ul">{`adds context api (ec94884f)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-9"
    }}>{`Documentation`}</h3>
    <ul>
      <li parentName="ul">{`adds stories to modal component (c12a633a)`}</li>
      <li parentName="ul">{`fixes responsiveness story of pageheader component. (912a2246)`}</li>
      <li parentName="ul">{`update guidelines for writing stories and patterns of components. (96159ad2)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "220-0--2021-07-01"
    }}>{`2.2.0-0  (2021-07-01)`}</h2>
    <h3 {...{
      "id": "highlights-10"
    }}>{`Highlights`}</h3>
    <ul>
      <li parentName="ul">{`New component EditableChipInput added. (18d702a7)`}</li>
    </ul>
    <h3 {...{
      "id": "breaking-changes-10"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-10"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-10"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-10"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`New component EditableChipInput added. (18d702a7)`}</li>
    </ul>
    <h3 {...{
      "id": "fixes-10"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Adds width and height property to checkbox in unchecked state. (c2561f34)`}</li>
      <li parentName="ul">{`fixes GridBody scrollTop issue on unmount. (766b5686)`}</li>
      <li parentName="ul">{`updates pagination component according to design. (601c3a47)`}</li>
      <li parentName="ul">{`fixes expanded state on initial render of Collapsible component. (e2967a7b)`}</li>
      <li parentName="ul">{`fixes single line case for width<240px in ChipInput. (92a37b6f)`}</li>
      <li parentName="ul">{`fixes slider tooltip to move with pointer in Slider component. (f1698ff3)`}</li>
      <li parentName="ul">{`fixes label onClick handling of MultiSlider component (ff4af117)`}</li>
      <li parentName="ul">{`Updates DS-`}<em parentName="li">{` to Design-System-`}</em>{` as data-test attribute value in components. (6956653e)`}</li>
      <li parentName="ul">{`fixes label inside tooltip to show custom label in Slider component (5ff6f838)`}</li>
      <li parentName="ul">{`Layout patterns styling and layout fixed. (e3b52908)`}</li>
      <li parentName="ul">{`Button Spinner loading state fixed. (bd8d9436)`}</li>
      <li parentName="ul">{`Show More button added in code preview panel. (134ef48a)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-10"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`skip feature for a step is addded in Stepper component (d4b775db)`}</li>
      <li parentName="ul">{`now Modal, Sidesheet and FullScreenModal components have uniform APIs (2c25d036)`}</li>
      <li parentName="ul">{`updated test cases for overlayheader, modal, sidesheet, EmptyState, Row, Column components.`}</li>
      <li parentName="ul">{`removes width: 100% and updates flex in Row component. (875564e7)`}</li>
      <li parentName="ul">{`adds box-shadow to focus state of Input component. (93b6356d)`}</li>
      <li parentName="ul">{`adds width 100% to MetricInput component. (267b2ad7)`}</li>
      <li parentName="ul">{`Bottom border radius added for tabs. (905e09b0) `}</li>
      <li parentName="ul">{`Cursor not allowed added for disabled tab component state. (716ed6c5)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-10"
    }}>{`Documentation`}</h3>
    <ul>
      <li parentName="ul">{`Updates stories of Table, PageHeader, Input components.`}</li>
      <li parentName="ul">{`adds placeholder story for Loaders component. (c8622a2e)`}</li>
      <li parentName="ul">{`updates the appearance variant story of Icon component. (42f654d9)`}</li>
      <li parentName="ul">{`adds pattern, disabled and error state stories for VerificationInput component. (bb8ea8cd)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "213--2021-06-10"
    }}>{`2.1.3  (2021-06-10)`}</h2>
    <h3 {...{
      "id": "highlights-11"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-11"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-11"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-11"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-11"
    }}>{`Features`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "fixes-11"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Adds width and height to checkbox in unchecked state. (c2561f34)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-11"
    }}>{`Improvements`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "documentation-11"
    }}>{`Documentation`}</h3>
    <p>{`NA`}</p>
    <hr></hr>
    <h2 {...{
      "id": "212--2021-05-26"
    }}>{`2.1.2  (2021-05-26)`}</h2>
    <h3 {...{
      "id": "highlights-12"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-12"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-12"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-12"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-12"
    }}>{`Features`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "fixes-12"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`downgrades js-beautify to v1.10.3 for supporting node 8.x  (d0c0206b)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-12"
    }}>{`Improvements`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "documentation-12"
    }}>{`Documentation`}</h3>
    <ul>
      <li parentName="ul">{`Fixes Alignment and Group stories for Checkbox component. (37d2412e)`}</li>
      <li parentName="ul">{`Fixes width of overflow story for Radio component. (5c632a2d)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "211--2021-05-26"
    }}>{`2.1.1  (2021-05-26)`}</h2>
    <h3 {...{
      "id": "highlights-13"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-13"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-13"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-13"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-13"
    }}>{`Features`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "fixes-13"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`downgrades js-beautify to v1.10.3 for supporting node 8.x  (a540fb95)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-13"
    }}>{`Improvements`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "documentation-13"
    }}>{`Documentation`}</h3>
    <p>{`NA`}</p>
    <hr></hr>
    <h2 {...{
      "id": "210--2021-05-26"
    }}>{`2.1.0  (2021-05-26)`}</h2>
    <h3 {...{
      "id": "highlights-14"
    }}>{`Highlights`}</h3>
    <ul>
      <li parentName="ul">{`New component for tag based input is added as `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`ChipInput`}</code>{`. (dddcefb0)`}</li>
      <li parentName="ul">{`Atomic components support all native HTML attributes as props now. (917918b9)`}</li>
    </ul>
    <h3 {...{
      "id": "breaking-changes-14"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-14"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-14"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-14"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Grid component can now preserve previous page scroll position. (98aa9085)`}</li>
      <li parentName="ul">{`Atomic components support all native HTML attributes as props now. (917918b9)`}</li>
      <li parentName="ul">{`New component for tag based input is added as `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`ChipInput`}</code>{`. (dddcefb0)`}</li>
    </ul>
    <h3 {...{
      "id": "fixes-14"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Click event on disabled options of Dropdown component is fixed. (8e58516b)`}</li>
      <li parentName="ul">{`Row component includes flex-grow in its style properties. (20645578)`}</li>
      <li parentName="ul">{`Scrolling on body is now restored after un-mounting of Backdrop component. (60274751)`}</li>
      <li parentName="ul">{`Next button in forms pattern is fixed. (93947e39)`}</li>
      <li parentName="ul">{`upgrades @actions/core version from 1.2.6 to 1.2.7 (55bbe718)`}</li>
      <li parentName="ul">{`upgrades js-beautify version from 1.10.3 to 1.13.13 (a9d2413d)`}</li>
      <li parentName="ul">{`Loading state is fixed for searching in Dropdown. (7543c883)`}</li>
      <li parentName="ul">{`Loading state is fixed for searching in Table. (715c0483)`}</li>
      <li parentName="ul">{`Fixed story path for Dialog. (4785c838)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-14"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`FileUploaderItem component now uses icon button in stead of Icon component for actions. (12cff689)`}</li>
      <li parentName="ul">{`Tabs component now have some more states for hovering over. (ac05ee66)`}</li>
      <li parentName="ul">{`Margin between inputs of VerificationCodeInput component is updated. (c835e770)`}</li>
      <li parentName="ul">{`Opacity in Message component as design improvement is added. (1b707bef)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-14"
    }}>{`Documentation`}</h3>
    <ul>
      <li parentName="ul">{`Updates Pagination component stories. (e132ebfc)`}</li>
      <li parentName="ul">{`Updates Tabs component stories. (4774231e)`}</li>
      <li parentName="ul">{`Updates Popover component stories. (24db67d9)`}</li>
      <li parentName="ul">{`Updates Checkbox component stories. (24753996)`}</li>
      <li parentName="ul">{`Updates Radio component stories. (8b30b313)`}</li>
      <li parentName="ul">{`Updates highlight story of Card component. (c8a2fd84)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "210-0--2021-05-07"
    }}>{`2.1.0-0  (2021-05-07)`}</h2>
    <h3 {...{
      "id": "highlights-15"
    }}>{`Highlights`}</h3>
    <ul>
      <li parentName="ul">{`New components added to library for metric values input and verification code input, namely `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`VerificationCodeInput`}</code>{` and `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`MetricInput`}</code>{`.`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`Enzyme`}</code>{` testing library is removed from project, now our test cases are using react-testing-library and jest only.`}</li>
    </ul>
    <h3 {...{
      "id": "breaking-changes-15"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-15"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-15"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-15"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Adds new component VerificationCodeInput for verification code input. (6ec9218a)`}</li>
      <li parentName="ul">{`Adds new component MetricInput for verification code input. (5632589d)`}</li>
    </ul>
    <h3 {...{
      "id": "fixes-15"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Radio component css issue fixed. (b9049771)`}</li>
      <li parentName="ul">{`Checkbox component css issue fixed. (d5036517)`}</li>
      <li parentName="ul">{`Sorting of story titles in left navigation menu on storybook fixed for parent level menus. (d10d451e)`}</li>
      <li parentName="ul">{`Enzyme is completely removed from library and snapshots are updated accordingly. (d511f73c)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-15"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`Text component’s subtle variant color updated. (32d2fe9c)`}</li>
      <li parentName="ul">{`Button component’s button size for large icons updated. (65b100c2)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-15"
    }}>{`Documentation`}</h3>
    <ul>
      <li parentName="ul">{`Stories of `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`VerticalNav`}</code>{` component updated according to updated documentation and features. (87c5955e)`}</li>
      <li parentName="ul">{`Stories of `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Dropdown`}</code>{` component updated according to updated documentation and features. (70329569)`}</li>
      <li parentName="ul">{`Stories of `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Toast`}</code>{` component updated according to updated documentation and features. (b9e20b78)`}</li>
      <li parentName="ul">{`Stories of `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Switch`}</code>{` component updated according to updated documentation and features. (c66e5e55)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "200--2021-04-28"
    }}>{`2.0.0  (2021-04-28)`}</h2>
    <h3 {...{
      "id": "highlights-16"
    }}>{`Highlights`}</h3>
    <ul>
      <li parentName="ul">{`Released 2.x of design system components.`}</li>
      <li parentName="ul">{`Support for storybook 6.`}</li>
      <li parentName="ul">{`Ability to edit component usage example on code sandbox on one click.`}</li>
      <li parentName="ul">{`Embed mode for minimal story embedding.`}</li>
      <li parentName="ul">{`New components introduced like Collapsible, CardHeader, CardBody, CardSubdued, CardFooter.`}</li>
      <li parentName="ul">{`Improved api design and features of navigation components.`}</li>
      <li parentName="ul">{`Calendar supports different sizes now.`}</li>
      <li parentName="ul">{`Manual changelog creation and review process.`}</li>
      <li parentName="ul">{`Separate library for charts, removed charts from components library.`}</li>
    </ul>
    <h3 {...{
      "id": "breaking-changes-16"
    }}>{`Breaking changes`}</h3>
    <ul>
      <li parentName="ul">{`Recharts is removed from dependency and DonutChart component is removed from library. (adef7f46)`}</li>
    </ul>
    <h3 {...{
      "id": "migration-guide-16"
    }}>{`Migration guide`}</h3>
    <ul>
      <li parentName="ul">{`For DonutChart (if you are using) install the library `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`@innovaccer/charts`}</code>{` and import the component from it like `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`import { DonutChart } from @innovaccer/charts`}</code>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "features-16"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Adds HorizontalNav and VerticalNav as new components. (a5c02f61)`}</li>
      <li parentName="ul">{`New components to support Card component, CardHeader, CardBody, CardFooter and CardSubdued are added. (1dbae2f1)`}</li>
    </ul>
    <h3 {...{
      "id": "fixes-16"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Fixes scroll issue in List component. (c7f11e5f)`}</li>
      <li parentName="ul">{`Fixes Label component’s line-height. (4e33460b)`}</li>
      <li parentName="ul">{`Removes redundant wrapper div from Textarea component. (18d60c48)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-16"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`Removes automatic changelog generation. (fb27f302)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-16"
    }}>{`Documentation`}</h3>
    <ul>
      <li parentName="ul">{`Updates Card component stories. (5ce568f8)`}</li>
      <li parentName="ul">{`Updates Message component stories. (fa5a70fe)`}</li>
      <li parentName="ul">{`Updates HorizontalNav component stories. (19b6f28b)`}</li>
      <li parentName="ul">{`Improved css utilities documentation with ability to copy tokens and class names on a single click. (3afc8d05)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "v200-6--2021-04-22"
    }}>{`v2.0.0-6  (2021-04-22)`}</h2>
    <h3 {...{
      "id": "highlights-17"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-17"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-17"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-16"
    }}>{`Deprecations`}</h3>
    <ul>
      <li parentName="ul">{`Description as a children in Message component is now deprecated, Please use description prop.`}</li>
    </ul>
    <h3 {...{
      "id": "features-17"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Adds support for Icon sizes in Button component. (69f0d1a7)`}</li>
    </ul>
    <h3 {...{
      "id": "fixes-17"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Fixes column size 3 issues. (71d608f1)`}</li>
      <li parentName="ul">{`Removes @types/classnames library, to use updated version of classnames library. (41809fa2)`}</li>
      <li parentName="ul">{`Fixes layering of multiple overlays. (a86eb33b)`}</li>
      <li parentName="ul">{`Fix controlled Dropdown search functionality issue. (e3e162ba)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-17"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`In Message component support for actions is added and component is redesigned according to new design. Also support for description prop is added and children is deprecated. (63c22d1e)`}</li>
      <li parentName="ul">{`In Label component ability to show optional hint as ‘Optional’ is added. (38ef846b)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-17"
    }}>{`Documentation`}</h3>
    <ul>
      <li parentName="ul">{`Updates Button component stories. (91920acd)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "v200-5--2021-04-14"
    }}>{`v2.0.0-5  (2021-04-14)`}</h2>
    <h3 {...{
      "id": "highlights-18"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-18"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-18"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-17"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-18"
    }}>{`Features`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "fixes-18"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Minor issues with liveEditor in DocPage are fixed. (007486c3)`}</li>
      <li parentName="ul">{`Updates sizing for small variant of Calendar component. (67f00da9)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-18"
    }}>{`Improvements`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "documentation-18"
    }}>{`Documentation`}</h3>
    <p>{`NA`}</p>
    <hr></hr>
    <h2 {...{
      "id": "v200-4--2021-04-08"
    }}>{`v2.0.0-4  (2021-04-08)`}</h2>
    <h3 {...{
      "id": "highlights-19"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-19"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-19"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-18"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-19"
    }}>{`Features`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "fixes-19"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Fixes issue in updating horizontal scroll of Grid (Table). (35f44c96)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-19"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`Updates header label of Table component. (9d42ab1a)`}</li>
      <li parentName="ul">{`Adds react-dynamic-virtual-scroll library in table to improve scrolling. (1b721f6d)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-19"
    }}>{`Documentation`}</h3>
    <p>{`NA`}</p>
    <hr></hr>
    <h2 {...{
      "id": "v200-3--2021-04-02"
    }}>{`v2.0.0-3  (2021-04-02)`}</h2>
    <h3 {...{
      "id": "highlights-20"
    }}>{`Highlights`}</h3>
    <ul>
      <li parentName="ul">{`Calendar available in different sizes.`}</li>
    </ul>
    <h3 {...{
      "id": "breaking-changes-20"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-20"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-19"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-20"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Introduced different sizes in Calendar component, now Calendar component sizes can be controlled by prop exposed for the same. (55f4207e)`}</li>
      <li parentName="ul">{`In DocPage ability to hide and show code on button click is added and feature to keep code panel expanded by default in embed mode is added. (ded41856) `}</li>
    </ul>
    <h3 {...{
      "id": "fixes-20"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`In Breadcrumbs component Link component is used and removed old local subtleLink component. (e866178f)`}</li>
      <li parentName="ul">{`Scroll inside Collapsible panel component is fixed. (ded41856)`}</li>
      <li parentName="ul">{`classnames library version 2.2.6 is frozen to avoid unwanted updates and breaks. (ded41856)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-20"
    }}>{`Improvements`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "documentation-20"
    }}>{`Documentation`}</h3>
    <p>{`NA`}</p>
    <hr></hr>
    <h2 {...{
      "id": "v200-2--2021-03-31"
    }}>{`v2.0.0-2  (2021-03-31)`}</h2>
    <h3 {...{
      "id": "highlights-21"
    }}>{`Highlights`}</h3>
    <ul>
      <li parentName="ul">{`New component: Collapsible`}</li>
      <li parentName="ul">{`Ability to edit and preview components directly in codeSandbox on single click.`}</li>
    </ul>
    <h3 {...{
      "id": "breaking-changes-21"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-21"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-20"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-21"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Introduced noSandbox prop in story’s docPage parameter to disable edit in code sandbox feature for specific story. (073dc0e8)`}</li>
      <li parentName="ul">{`new component Collapsible is added. (90c3a954)`}</li>
      <li parentName="ul">{`adds codeSandbox integration in docs page story preview. (0cdcbb33)`}</li>
    </ul>
    <h3 {...{
      "id": "fixes-21"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Calendar component added to library build. (e3bb7dab)`}</li>
      <li parentName="ul">{`Fixes FullscreenModal’s header for close button alignment. (7d269b8a)`}</li>
      <li parentName="ul">{`Updates html code indentation used in code sandbox. (eedd4bd6)`}</li>
      <li parentName="ul">{`Adds import generator to generate component imports for show code and edit in codeSandbox source codes. (becf40a3)`}</li>
      <li parentName="ul">{`Updates configs to support Story book version 6. (be41707e)`}</li>
      <li parentName="ul">{`updates titles of all stories to support SB6.  (dd072353)`}</li>
      <li parentName="ul">{`update title of page to be as of story title, enables args table tab. (c3ce929d)`}</li>
      <li parentName="ul">{`Support for month nav is fixed in Calendar component. (7cacd5bd)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-21"
    }}>{`Improvements`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "documentation-21"
    }}>{`Documentation`}</h3>
    <ul>
      <li parentName="ul">{`Updates Button component stories. (5f8b8a9f)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "v200-1--2021-03-24"
    }}>{`v2.0.0-1  (2021-03-24)`}</h2>
    <h3 {...{
      "id": "highlights-22"
    }}>{`Highlights`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "breaking-changes-22"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-22"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-21"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-22"
    }}>{`Features`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "fixes-22"
    }}>{`Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Fixes Layout (ROW, Column) components styling according to bootstrap css. (6fa16085)`}</li>
    </ul>
    <h3 {...{
      "id": "improvements-22"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`Removes all stories rendering from doc page of a single component and adds show and hide feature for source code of story on docPage. (9d4d216d)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-22"
    }}>{`Documentation`}</h3>
    <p>{`NA`}</p>
    <hr></hr>
    <h2 {...{
      "id": "v200-0--2021-03-19"
    }}>{`v2.0.0-0  (2021-03-19)`}</h2>
    <h3 {...{
      "id": "highlights-23"
    }}>{`Highlights`}</h3>
    <ul>
      <li parentName="ul">{`Support for storybook 6 added.`}</li>
    </ul>
    <h3 {...{
      "id": "breaking-changes-23"
    }}>{`Breaking changes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "migration-guide-23"
    }}>{`Migration guide`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "deprecations-22"
    }}>{`Deprecations`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "features-23"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`upgrades storybook to 6.x, and all its dependencies to supported versions. (de09643a)`}</li>
      <li parentName="ul">{`Fixes Badge component styling. (4d77d53f)`}</li>
    </ul>
    <h3 {...{
      "id": "fixes-23"
    }}>{`Fixes`}</h3>
    <p>{`NA`}</p>
    <h3 {...{
      "id": "improvements-23"
    }}>{`Improvements`}</h3>
    <ul>
      <li parentName="ul">{`Updates default style for Column component. (2c0b07c8)`}</li>
      <li parentName="ul">{`Adds size and appearance support in Link component. (3b6eee89)`}</li>
      <li parentName="ul">{`Adds support for count in horizontal navigation. (5a930857)`}</li>
    </ul>
    <h3 {...{
      "id": "documentation-23"
    }}>{`Documentation`}</h3>
    <p>{`NA`}</p>
    <hr></hr>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      